import { ContainerComponent, wrap, Store, } from 'AppReact';
import { IconTextButton, Input } from 'molecules';
import { FlexBetweenWrapper, FlexCenterWrapper, Mt2, Mb1 } from 'wrappers'
import { ModalCloseButton, PlusSignSvg } from 'components/icons';
import { ClickableIcon, SecondaryTextXsBold } from 'atoms';
import Controller from './controller';
import internalState from './internalState';


export const definition = {
  name: 'Credentials',
  controller: Controller,
  initialProps: ({ credentials }) => ({ credentials }),
  props: internalState,
  elements: [
    { 
      component: wrap(SecondaryTextXsBold, Mb1),
      name: 'Header',
      displayValue: () => 'Credentials',
    },
    {
      wrapper: FlexBetweenWrapper,
      name: 'ContentWrapper',
      isListOf: 'credentials',
      elements: [
        {
          component: Input,
          name: 'Name',
          bindings: ({ credentials, credential, credentialIndex }) => ({ credentials, credential, credentialIndex, label: "Name: ", placeholder: 'Enter the credential name', value: credential?.name ?? "" })
        },
        {
          component: Input,
          name: 'Value',
          bindings: ({ credentials, credential, credentialIndex }) => ({ credentials, credential, credentialIndex, label: "Value: ", placeholder: 'Enter Value', value: credential.value ?? "" })
        },
        {
          component: ClickableIcon,
          name: 'Delete',
          displayValue: ({ }) => ModalCloseButton({ width: 22, height: 22, xColor: window?.settings?.primary_color ?? '#1DBD6B' }),
          bindings: ({ credentials, credential, credentialIndex }) => ({ credentials, credential, credentialIndex})
        }
      ]
    },
    {
      component: wrap(wrap(IconTextButton, FlexCenterWrapper), Mt2),
      name: 'AddNew',
      bindings: ({ credentials }) => ({ credentials, icon: PlusSignSvg({}), title: 'Add Credential' })
    }
  ]
};

export default ContainerComponent(definition);